import axios from "axios";

const SKILL_PROVIDER_AUTH_STORAGE_KEY = "skill-provider-login-user";

const getStoredSkillProviderUser = () => {
  try {
    const storedUser = localStorage.getItem(SKILL_PROVIDER_AUTH_STORAGE_KEY);
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    localStorage.removeItem(SKILL_PROVIDER_AUTH_STORAGE_KEY);
    return null;
  }
};

const skillProviderHttpCommon = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

skillProviderHttpCommon.interceptors.request.use(
  (config) => {
    const token = config.skipAuth ? null : getStoredSkillProviderUser()?.token;

    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

skillProviderHttpCommon.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(SKILL_PROVIDER_AUTH_STORAGE_KEY);
      window.location.href = "/skill-provider-portal/login";
    }

    return Promise.reject(error);
  },
);

export default skillProviderHttpCommon;
